import React, { PureComponent } from "react";

export default class ES extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#ffda44"
          />
          <g>
            <rect
              width="512"
              height="113.775"
              transform="translate(0 85.331)"
              fill="#d80027"
            />
            <rect
              width="512"
              height="113.775"
              transform="translate(0 312.882)"
              fill="#d80027"
            />
          </g>
        </g>
      </svg>
    );
  }
}
